/**
 * Toutes les fonctions de clean du chart
 * @param {ref} currentChart
 */
export const useCleanChart = () => {
  const removeXAxes = currentChart => {
    while (currentChart.xAxes.length >= 1) {
      currentChart.xAxes.removeIndex(0).dispose()
    }
  }

  const removeYAxes = currentChart => {
    while (currentChart.yAxes.length >= 1) {
      currentChart.yAxes.removeIndex(0).dispose()
    }
  }

  const removeAllSeries = currentChart => {
    while (currentChart.series.length >= 1) {
      currentChart.series.removeIndex(0).dispose()
    }
  }

  const cleanChart = currentChart => {
    removeXAxes(currentChart)
    removeYAxes(currentChart)
    removeAllSeries(currentChart)
  }

  return {
    removeAllSeries,
    removeYAxes,
    removeXAxes,
    cleanChart,
  }
}
